import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { CHANGE_TAB } from "../../constants/actionTypes";
import { profileUpdateService } from "../../Network/services/profileUpdateService";
import { useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import Files from "react-files";
import { ToastContainer, toast } from "react-toastify";
import TagsInput from "react-tagsinput";
import DatePicker from "react-datepicker";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";
import "react-tagsinput/react-tagsinput.css";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-dropdown-select";
import Geocode from "react-geocode";
import "./KycEditView.css";


const mapStateToProps = (state) => ({
  ...state.articleList,
});

const mapDispatchToProps = (dispatch) => ({
  onTabClick: (tab, pager, payload) =>
    dispatch({ type: CHANGE_TAB, tab, pager, payload }),
});

const KycEditView = (props) => {
  
  let location = useLocation();
  let history = useHistory();
  
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [name, setName] = useState("");
  const [idNumberShow, setIdNumberShow] = useState(true);
  const [idprooftype, setIdprooftype] = useState();
  const [idproofnumber, setIdproofnumber] = useState();
  const [capchaVideoFile, setCapchaVideoFile] = useState();
  const [capchaInfo, setCapchaInfo] = useState();

  const [kycSubmitBtn,setKycSubmitBtn] = useState("ADD KYC")

  const [aadharCaptcha, setAadharCaptcha] = useState([]);
  const [sessionId, setSessionId] = useState("");
  const [captchaImage, setCaptchaImage] = useState("");
  const [verifyotp, setverifyotp] = useState(false);
  
  const [buttonLoading, setButtonLoading] = useState(false);
  const [showDigilockerSection, setShowDigilockerSection] = useState(false);

  
  const [panCardName, setPanCardName] = useState("");
  const [panCardDob, setPanCardDob] = useState("");
  const [currentLocation, setCurrentLocation] = useState("");


  const getCurrentLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          Geocode.setApiKey(process.env.REACT_APP_GOOGLE_LOCATION_API_KEY);
          Geocode.setLanguage("en");
          Geocode.setRegion("in");
          Geocode.setLocationType("ROOFTOP");
          Geocode.enableDebug();
          Geocode.fromLatLng(position.coords.latitude, position.coords.longitude).then(
            (response) => {
              const fullAddress = response.results[0].formatted_address;
              setCurrentLocation(fullAddress);
            },
            (error) => {
              console.error(error);
              toast.error("Failed to get location. Please try again.", {
                position: "top-right",
                autoClose: 3000,
              });
            }
          );
        },
        (e) => {
          console.error("Geolocation error:", e);
          toast.error("Location access denied. Please enter location manually.", {
            position: "top-right",
            autoClose: 3000,
          });
        },
        {
          enableHighAccuracy: true
        }
      );
    } else {
      toast.error("Geolocation is not supported by your browser.", {
        position: "top-right",
        autoClose: 3000,
      });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0)

    getCurrentLocation();

    if (props.location && props.location.state && props.location.state.userInfo) {
      setCapchaVideoFile(props.location.state.userInfo[0]);
      setCapchaInfo(props.location.state.userInfo[1]);
    } else {
      console.warn("No userInfo found in location state. User may have navigated directly to this page.");
    }

    try {
      let user = JSON.parse(window.localStorage.getItem("UserData"));
      if (user) {
        setName(user.first_name + " " + user.last_name);
      } else {
        console.warn("No user data found in localStorage");
        setHasError(true);
        setErrorMessage("Please log in to access KYC verification.");
        return;
      }
    } catch (error) {
      console.error("Error parsing user data:", error);
      setHasError(true);
      setErrorMessage("Error loading user data. Please try again.");
      return;
    }


    
 
  }, []);


  let back = (e) => {
    e.preventDefault();
    history.goBack();
  };


   const profileupdate = async (e) => {
    e.preventDefault();
    
    // Validation for PAN Card fields
    if(idprooftype == "1") {
      if(!panCardName.trim()) {
        toast.error("Please enter name as per PAN Card", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
        return;
      }
      if(!panCardDob) {
        toast.error("Please select date of birth as per PAN Card", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
        return;
      }
    }
    
    if(!idproofnumber.trim()) {
      toast.error("Please enter ID proof number", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if(!capchaVideoFile) {
      toast.error("Please record a video for KYC verification", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    setLoading(true);
    
    let myFile = capchaVideoFile;
    
    if (capchaVideoFile && capchaVideoFile.constructor.name === 'Blob') {
      const timestamp = new Date().getTime();
      const fileName = `kyc_video_${timestamp}.mp4`;
      
      myFile = new File([capchaVideoFile], fileName, {
        type: "video/mp4"  
      });
    }
    const form = new FormData();
    form.append('id_proof_type', idprooftype);
    form.append('id_proof_number', idproofnumber);
    form.append("kyc_current_location", currentLocation || '')
    // if (capchaVideoFile) {
    
    //   try {
    //     if (myFile instanceof File || myFile instanceof Blob) {
         
    //       form.append('file', myFile,  'video.mp4');
    //     }
    //   } catch (error) {
    //     console.error('Error processing file:', error);
    //   }
    // }
    // form.append('kyc_captcha_code', capchaInfo || '');
    if(idprooftype=="1"){  // PAN Card
        form.append('pan_card_name', panCardName);
        form.append('date_of_birth', panCardDob ? moment(panCardDob).format('DD/MM/YYYY') : '');
    }
    
    profileUpdateService
      .kycPanGstUpload(form,idprooftype)
      .then(async (res) => {
        if (res.status == 200) {
          if(idprooftype==3){

            setverifyotp(true);
            setSessionId(res.data.session_id);
            toast.success(res.message, {            
              position: "top-right",
              type: "success",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
          }
          else{
            history.push("/profile");
            window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
            window.localStorage.setItem("auth_token", res.data[0].auth_token);
            toast.success(res.message, {            
              position: "top-right",
              type: "success",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
          }         
        
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success("Something went wrong! please try again later!!", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };


  const initiateDigiLockerVerification = (e) => {
    e.preventDefault();
    setButtonLoading(true);
    
    const form = new FormData();
   
    profileUpdateService
      .initiateAadhaarVerification(form)
      .then(async (res) => {
        if (res.status == 200) {

          
          if (res.data && res.data.redirect_url) {
            sessionStorage.setItem('kycVerificationData', JSON.stringify({
              status: 'pending',
              message: res.message,
              data: res.data,
              timestamp: new Date().toISOString(),
              redirect_url: res.data.redirect_url,
              capchaVideoFile: capchaVideoFile
            }));
            
            window.location.href = res.data.redirect_url;
          } else {
            toast.error("Redirect URL not found in response", {
              position: "top-right",
              autoClose: 5000,
            });
            setButtonLoading(false);
          }
        
        } else {
          toast.error(res.message || "Failed to initiate Aadhaar verification", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          });
          setButtonLoading(false);
        }
      })
      .catch((err) => {
        console.error("DigiLocker API Error:", err);
        toast.error("Failed to initiate Aadhaar verification. Please try again.", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
        setButtonLoading(false);
      });
  };


  function resumeChange(e) {
    setCapchaVideoFile(e.target.files[0])
  }

  function idDropdownChange(e) {
    setIdprooftype(e.target.value)
    if(e.target.value==3){
        setShowDigilockerSection(true);
    }
    else{
        setKycSubmitBtn("ADD KYC")
        setIdNumberShow(true);
        setShowDigilockerSection(false);
    }
  }

  if (hasError) {
    return (
      <>
        <section className="explore explore1">
          <div className="container">
              <div className="banner">
                <div className="row">
                  <div className="col-md-4">
                    <div className="breadcrumps">
                      <ul>
                        <li>
                          <a href="#!" onClick={(e) => back(e)}>
                            <i className="bx bx-chevron-left" /> Back to Verify user
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <section className="onbord-section">
                <div className="row">
                  <div className="col-md-12 text-center">
                    <h1 className="title">Fill eKYC</h1>
                    <p className="subtitle"></p>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="board-box board-box2 post-new-job">
                      <div className="form-group text-center kyc-error-container">
                        <div className="kyc-error-icon">
                          <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
                        </div>
                        <h3 className="kyc-error-title">Access Error</h3>
                        <p className="kyc-error-message">
                          {errorMessage}
                        </p>
                        <button 
                          onClick={() => history.push("/login")}
                          className="kyc-error-button kyc-error-button-primary"
                        >
                          Go to Login
                        </button>
                        <button 
                          onClick={() => history.push("/profile")}
                          className="kyc-error-button kyc-error-button-secondary"
                        >
                          Back to Profile
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
            </div>
        </section>
      </>
    );
  }

  return (
    <>
      <section className="explore explore1">
      <div className="container">
        <div className="banner">
          <div className="row">
            <div className="col-md-4">
              <div className="breadcrumps">
                <ul>
                  <li>
                    <a href="#!" onClick={(e) => back(e)}>
                      <i className="bx bx-chevron-left" /> Back to Verify user
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <section className="onbord-section">
      
          <div className="row">
            <div className="col-md-12 text-center">
              <h1 className="title">Fill eKYC</h1>
              <p className="subtitle"></p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              
              <div className="board-box board-box2 post-new-job">

                <form>

                  <div className="form-group">
                    <select className="form-control" value={idprooftype} onChange={idDropdownChange}>
                        <option >*ID Proof Type</option>
                        <option value="3">Aadhaar(Prefered)</option>
                        <option value="1">PAN Card</option>
                        <option value="2">Company GSTIN</option>
                    </select>
                  </div>

                  {showDigilockerSection && (
                    <>
                      <div className="form-group margin-bottom2">
                        <h3 className="kyc-digilocker-title">Aadhaar Verification</h3>
                      </div>
                      
                      <div className="form-group margin-bottom2 kyc-digilocker-container">
                        <div className="kyc-digilocker-icon">
                         <img src="/assets/images/DigiLockerLogo.svg" />
                        </div>
                      </div>
                      
                      <div className="form-group margin-bottom2">
                        <p className="kyc-digilocker-description">
                          Verify your Aadhaar using DigiLocker for secure and quick verification
                        </p>
                      </div>
                      
                      <button 
                        className="kyc-digilocker-button"
                        onClick={initiateDigiLockerVerification}
                        disabled={buttonLoading}
                      >
                        {buttonLoading ? (
                          <>
                            <span className="kyc-digilocker-spinner"></span>
                            Processing...
                          </>
                        ) : (
                          'Open DigiLocker'
                        )}
                      </button>
                    </>
                  )}
                  

                  {(idNumberShow && !showDigilockerSection) && 
                    <>
                        <div className="form-group ">
                        <input 
                          type="text" 
                          className="form-control" 
                          required="required" 
                          placeholder="ID Number" 
                          onChange={(e) => { setIdproofnumber(e.target.value.toUpperCase()); }} 
                          style={{ textTransform: 'uppercase' }}
                          value={idproofnumber || ''}
                        />
                        </div>
                        
                        {idprooftype == "1" && (
                          <>
                            <div className="form-group ">
                              <input 
                                type="text" 
                                className="form-control" 
                                required="required" 
                                placeholder="Name as per PAN Card" 
                                value={panCardName}
                                onChange={(e) => { setPanCardName(e.target.value); }} 
                              />
                            </div>
                            <div className="form-group ">
                              <DatePicker
                                selected={panCardDob}
                                onChange={(date) => setPanCardDob(date)}
                                className="form-control"
                                placeholderText="Date of Birth as per PAN Card"
                                dateFormat="dd/MM/yyyy"
                                maxDate={new Date()}
                                showYearDropdown
                                scrollableYearDropdown
                                yearDropdownItemNumber={100}
                                required
                              />
                            </div>
                          </>
                        )}
                        
                    </>
                    
                  }


                  {!showDigilockerSection && (
                    <button onClick={profileupdate} style={{marginTop: "20px"}}>{kycSubmitBtn}</button>
                  )}




                  
                </form>


              </div>

            </div>
          </div>

        </section>
      </div>
    
    </section>
    </>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(KycEditView);
